import React, { useState, useEffect, Fragment } from "react";
import { Table, Button } from "reactstrap";
import ModalSinonyms from "../../Modals/ModalSinonyms";
import { LoadingMessage } from "../../Controls";
import { Mode, WizzMode } from "../../types";
import LaddaButton, { ZOOM_OUT, XS } from "react-ladda";
import { useEntities } from "../../Wizzard";
import classNames from "classnames";
import style from "./../../styles.module.scss";

const Sinonyms = ({
  mode,
  defaultId,
  assetSynonyms,
  services,
  dataProviders,
  assetId,
  wizzOnChange,
  wizzToggle,
}) => {
  const [readonly, setReadonly] = useState(mode == WizzMode.View);
  const [modalSinonyms, setModalSinonyms] = useState({ open: false });
  const [deleting, setDeleting] = useEntities({});

  useEffect(() => {
    if (mode) {
      setReadonly(mode == WizzMode.View);
    }
  }, [mode]);

  const toggle = (props) => {
    setModalSinonyms({ open: !modalSinonyms.open, ...props });
  };

  // handle grid actions
  const handleAction = (action, synonymId) => {
    if (action == Mode.Insert) {
      toggle({
        assetId,
        action,
        onConfirm: (e) => handleSave(action, e),
      });
    } else if (action == Mode.Update) {
      toggle({
        assetId,
        action,
        synonym: assetSynonyms.find((s) => s.DataProviderId == synonymId),
        onConfirm: (e) => handleSave(action, e),
      });
    } else if (action == Mode.Delete) {
      wizzToggle("confirm", {
        title: "Delete asset synonym",
        message: "Are you sure you want to delete asset synonym?",
        onConfirm: () => handleDelete(synonymId),
      });
    }
  };

  // callback after modal confirm
  const handleSave = (action, synonym) => {
    return services
      .updateSynonym({
        assetId,
        action,
        synonym,
      })
      .then((res) => res.result)
      .then((result) => {
        if (result.Code == 200) {
          wizzOnChange({
            Synonyms: [synonym].concat(
              assetSynonyms.filter((e) => e.DataProviderId != synonym.DataProviderId)
            ),
          });
        } else {
          wizzToggle("message", {
            title: "Error",
            message: result.Description,
          });
        }

        return result.Code;
      });
  };

  // callback after confirm delete
  const handleDelete = (id) => {
    setDeleting({ [id]: true });
    services
      .updateSynonym({
        assetId,
        action: Mode.Delete,
        synonym: assetSynonyms.find((e) => e.DataProviderId == id),
      })
      .then((res) => res.result)
      .then((result) => {
        setDeleting({ [id]: false });
        if (result.Code == 200) {
          assetSynonyms.splice(
            assetSynonyms.findIndex((e) => e.DataProviderId == id),
            1
          );
          wizzOnChange({
            Synonyms: assetSynonyms,
          });
        } else {
          wizzToggle("message", {
            title: "Error",
            message: result.Description,
          });
        }
      });
  };
  return (
    <div>
      {!readonly && (
        <Button color="primary" className="mb-3" onClick={() => handleAction(Mode.Insert)}>
          <i className="fa fa-plus mr-1" aria-hidden="true"></i>
          Add Sinonyms
        </Button>
      )}
      <Table>
        <thead>
          <tr>
            <th>Data Provider</th>
            <th>Asset Provider</th>
            <th>Trade Pricing</th>
            <th>Account Pricing</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {assetSynonyms ? (
            <Fragment>
              {assetSynonyms.map((item) => (
                <tr
                  key={`sin-${item.DataProviderId}`}
                  className={classNames({
                    [style.highlight]: item.DataProviderId == defaultId,
                  })}
                >
                  <td>{item.DataProviderName}</td>
                  <td>{item.AssetProviderName}</td>
                  <td>{item.AssetProviderTradePricing ? "Yes" : "No"}</td>
                  <td>{item.AssetProviderAccountingPricing ? "Yes" : "No"}</td>
                  <td>
                    {!readonly && (
                      <Actions
                        id={item.DataProviderId}
                        action={handleAction}
                        deleting={!!deleting[item.DataProviderId]}
                      />
                    )}
                  </td>
                </tr>
              ))}
              {assetSynonyms.length == 0 && <EmptyOrLoading />}
            </Fragment>
          ) : (
            <EmptyOrLoading loading={true} />
          )}
        </tbody>
      </Table>

      <ModalSinonyms {...modalSinonyms} toggle={toggle} services={services} dataProviders={dataProviders} />
    </div>
  );
};

const EmptyOrLoading = ({ loading }) => (
  <tr>
    <td colSpan="4">
      {loading ? (
        <LoadingMessage text="Loading sinonyms" />
      ) : (
        <span className="text-center d-block h5 m-3" style={{ textAlign: "center" }}>
          No sinonyms
        </span>
      )}
    </td>
  </tr>
);

const Actions = ({ action, id, deleting }) => (
  <div className="d-flex justify-content-end">
    <Button color="primary" size="sm" className="mr-2" onClick={() => action(Mode.Update, id)}>
      <i className="fa fa-pencil-square-o" aria-hidden="true"></i>
    </Button>

    <LaddaButton
      className="btn btn-ladda btn-danger btn-sm"
      loading={deleting}
      onClick={() => action(Mode.Delete, id)}
      data-style={ZOOM_OUT}
      data-size={XS}
    >
      <i className="fa fa-trash-o" aria-hidden="true"></i>
    </LaddaButton>
  </div>
);

const filterDataProviders = (dataProviders) => {};

export default Sinonyms;
